import { AppModal } from '@app/components/AppModal';
import AppAlert from '@app/components/AppAlert';
import { useState } from 'react';
import { setToTreatManyPotentielsParrainages } from '@app/api/data/potentiels-parrainages';
import AppLoading from '@app/components/AppLoading';

type props = {
    onSuccess: () => void;
    idToUpdate: number[];
    open: boolean;
    onClose: () => void;
};

export const SetToTreatPotentiels = ({
    idToUpdate,
    onSuccess,
    open,
    onClose,
}: props) => {
    const [loading, setLoading] = useState<boolean>(false);

    const submit = async () => {
        setLoading(true);
        try {
            await setToTreatManyPotentielsParrainages(idToUpdate);
            onSuccess();
            onClose();
        } catch (error) {
            console.error('Erreur lors du passage à "À traiter":', error);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }
    };

    return (
        <AppModal
            handleSubmit={submit}
            icon="ClockIcon"
            title={`Passer à "À traiter"`}
            submitText="Passer à À traiter"
            submitIcon="ClockIcon"
            open={open}
            onClose={onClose}
        >
            <div className="flex min-w-[400px] flex-col">
                <label className="mb-4">
                    {idToUpdate.length} potentiel(s) parrainage(s) à passer à "À traiter"
                </label>
                {loading ? (
                    <AppLoading />
                ) : (
                    <AppAlert
                        message={{
                            color: 'warning',
                            title: 'Passer à "À traiter"',
                            text: 'Passer les potentiels parrainages sélectionnés à "À traiter" ? Ils seront à nouveau visibles dans les listes normales.',
                        }}
                    />
                )}
            </div>
        </AppModal>
    );
};
export default SetToTreatPotentiels;

